const getCookie = (name) => {
    let cookieArr = document.cookie.split(";")

    for (let i=0; i<cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        
        if (name === cookiePair[0].trim()){
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return '';
}


const fetchNaverPayInfo = async (cart, backUrl, customerId) => {
    const url = 'https://howus-live.lukuku.co/payment/product-info'
    
    const nvadid = getCookie('NVADID')
    const cpavalidator = getCookie('CPAValidator')
    const naco = getCookie('NA_CO')

    const payload = { 
        cart,
        backUrl,
        customerId,
        nvadid,
        cpavalidator,
        naco,
    }
    
    return fetch(url, {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(response => response.json()) 
    .then(data => {
        if (data.status == 'success') {
            const paymentUrl = data.paymentUrl;
            const orderId = data.orderId;
            const shopId = data.shopId;
            const totalPrice = data.totalPrice;
            const requestUrl = `${paymentUrl}?ORDER_ID=${orderId}&SHOP_ID=${shopId}&TOTAL_PRICE=${totalPrice}` 
            window.location.href= requestUrl;
        }
    })
}


const pdp_buy_nc = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const baseUrl = url.origin + url.pathname;
    const queryString = currentUrl.split('?')[1];
    const params = new URLSearchParams(queryString);
    const variantId = params.get('variant');
    const firstVariantId = sessionStorage.getItem('pdp-firstVariantId');
    const customerId = window.customerId

    // 제품이 1개씩만 담을수 있음
    // const quantityInput = document.querySelector('[data-cart-quantity]')
    // const quantity = quantityInput.value
    const quantity = 1
    const payload = [{
        productVariantId: variantId || firstVariantId,
        quantity: quantity
    }]
    fetchNaverPayInfo(payload, baseUrl, customerId);
}

const cart_buy_nc = async () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const baseUrl = url.origin + url.pathname;
    const customerId = window.customerId;

    const payload = await fetch('cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then((res) => {
            const result = res.items.map((item) => {
                const price = Number(item.final_price)/100
                return {
                    productVariantId: item.variant_id,
                    quantity: item.quantity,
                    price: price,
                    discountedQuantity: item.quantity
                }
            })
            return result
        })
        .catch((err) => console.log('Error: ', err));
    fetchNaverPayInfo(payload, baseUrl, customerId);
}

const not_buy_nc = () => {
    alert("구매할 수 없습니다.");
    return;
}
const wishlist_nc = () => {
    console.log("wishlist!")
    return;
}